import React from 'react'
import { toMinuteString } from '../../../../lib/StringUtil'

import './PlayerTime.css'

export default class Time extends React.PureComponent {

	render() {

		const { time } = this.props
		const timeInfo = `${ toMinuteString(time) }`

		const style = {
			position: 'relative',
			top: -10,
		}

		return (
			<div
				style={style}
				className="player__time"
				>{timeInfo}
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/player/controls/time/PlayerTime.jsx